let config = {};

// Http 请求
config.httpTimeOut = 2400000;

// 分页配置
config.pagingConfig = {
    pageSizes: [10, 20, 50, 100],
    pageLayout: 'total, sizes, prev, pager, next, jumper',
};

config.page = {
    // 每页显示数据条数配置
    opts: [5, 10, 20, 50],
    // 每页显示数据条数
    pageSize: 10,
    // 分页组件的布局
    layout: 'total, prev, pager, next, sizes,jumper',
    // 最大页显示数
    maxPageSize: 99999
};

// ajax配置
config.ajax = {
    timeout: 120000,
    exportTimeout:120000
};

// 正则
config.Reg = {
    mobile: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
    email: /^[a-zA-Z0-9_.-]+@[A-Za-z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    tel: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/,
    intVal: /^[0-9]\d*$/,
    number: /^\d+(\.\d+)?$/,
    twoNumber: /^\d+(\.\d{0,2})?$/,
    zsVal: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
    enNumber: /^[A-Za-z0-9]+$/,
    lonReg: /^-?((0|1?[0-7]?[0-9]?)(([.][0-9]{1,4})?)|180(([.][0]{1,4})?))$/,
    latReg: /^-?((0|[1-8]?[0-9]?)(([.][0-9]{1,4})?)|90(([.][0]{1,4})?))$/,
    //最多保留两位数字
    numberDecimal:/^(([1-9]\d*|0)(|\.\d{1,3}))$/,
};

// 省份顺序
config.provinceSort = [
    '北京',
    '天津',
    '河北省',
    '山西省',
    '内蒙古自治区',
    '辽宁省',
    '吉林省',
    '黑龙江省',
    '上海',
    '江苏省',
    '浙江省',
    '安徽省',
    '福建省',
    '江西省',
    '山东省',
    '河南省',
    '湖北省',
    '湖南省',
    '广东省',
    '广西壮族自治区',
    '海南省',
    '重庆',
    '四川省',
    '贵州省',
    '云南省',
    '西藏自治区',
    '陕西省',
    '甘肃省',
    '青海省',
    '宁夏回族自治区',
    '新疆维吾尔自治区',
    '香港特别行政区',
    '澳门特别行政区',
    '台湾省',
];

config.corpNo = 'CO1524100773815';//'CORP1560154054723';

export default config;